import React, { useEffect, useState } from "react";
import {
  getCourseLessonLevelReports,
  getOverviewTexts,
  saveOverviewTexts,
} from "../../../lib/studentcourselessonreport";
import style from "./globalstudentcourselessonreport.module.css";
import { Toast, ToastContainer } from "react-bootstrap";
import { getColorClass , getHeaderClass } from "./globalstudentgparigorsummary";

const OVERVIEW_KEY = "clevelTest2";

export default function GlobalStudentCourseLessonLevelReport({
  studentId,
  isStudent = false,
}) {
  const [data, setData] = useState([]);
  const [levels, setLevels] = useState([]);
  const [overview, setOverview] = useState({});
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    loadData();
  }, [studentId]);

  const loadData = async () => {
    const raw = await getCourseLessonLevelReports(studentId);
    const sorted = raw.sort((a, b) => a.courseyear - b.courseyear);
    setData(sorted);

    // LEVELS: courseyear ve studentId dışındaki alanlar
    const dynamicLevels = new Set();
    sorted.forEach((row) => {
      Object.keys(row).forEach((key) => {
        if (!["courseyear", "studentId", "Total"].includes(key)) {
          dynamicLevels.add(key);
        }
      });
    });
  // Custom sort order for levels
  const customOrder = ["AP", "CC", "HR", "EA", "RG", "OT"];
  const sortedLevels = customOrder.filter(lvl => dynamicLevels.has(lvl));
  setLevels(sortedLevels);

    const overviewRaw = await getOverviewTexts(studentId);
    const overviewMap = {};
    overviewRaw.forEach((item) => {
      overviewMap[item.type] = item.desc;
    });
    setOverview(overviewMap);
  };

  const handleOverviewChange = (value) => {
    setOverview((prev) => ({ ...prev, [OVERVIEW_KEY]: value }));
  };

  const handleUpdate = async () => {
    await saveOverviewTexts(studentId, {
      [OVERVIEW_KEY]: overview[OVERVIEW_KEY] || "",
    });
    setShowToast(true);
    setToastMessage("Update successful!");
    setTimeout(() => setShowToast(false), 3000);
    loadData();
  };

  const getLevelTotal = (level) =>
    data.reduce((sum, row) => sum + (row[level] || 0), 0);

  const getRowTotal = (row) =>
    levels.reduce((sum, lvl) => sum + (row[lvl] || 0), 0);

  return (
    <div className="card p-3">
      <h4 className="mb-3">Course Load</h4>

      <ToastContainer style={{ top: "1rem", right: "1rem", position: "fixed" }}>
        <Toast
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notification</strong>
          </Toast.Header>
          <Toast.Body>{toastMessage}</Toast.Body>
        </Toast>
      </ToastContainer>

      {/*}<h5 className="mb-3">Number of Courses</h5> {*/}

      <table className="table table-bordered text-center">
        <thead>
          <tr>
            <th style={{ width: "150px" }}>Grade Level</th>
            <th>Total</th>
            {levels.map((lvl) => (
              <th key={lvl} className={getHeaderClass(lvl)}>{lvl}</th>
            ))}
            <th style={{ width: "400px" }}>Overview</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={row.courseyear}>
              <td>{`Grade-${row.courseyear}`}</td>
              <td className={style.totalCell}>
                {row.Total ?? getRowTotal(row)}
              </td>
              {levels.map((lvl) => (
                  <td key={lvl} className={row[lvl] > 0 ? getHeaderClass(lvl): ""}>
                {/*</td><td key={lvl} className={row[lvl] > 0 ? getColorClass(row[lvl] ?? 0, "gpa10") : ""}>*/}
                  {row[lvl] ?? 0}
                </td>
              ))}
              {index === 0 && (
                <td rowSpan={data.length + 1} className={style.overviewCell}>
                  {!isStudent ? (
                    <textarea
                      rows={data.length * 2}
                      className="form-control h-100"
                      style={{ resize: "none" }}
                      value={overview[OVERVIEW_KEY] || ""}
                      onChange={(e) => handleOverviewChange(e.target.value)}
                    />
                  ) : (
                    <div className="bg-light border rounded p-2 h-100 overflow-auto">
                      {overview[OVERVIEW_KEY]}
                    </div>
                  )}
                </td>
              )}
            </tr>
          ))}
          <tr>
            <td>
              <strong>TOTAL</strong>
            </td>
            <td className={style.totalCell}>
              {data.reduce(
                (sum, row) => sum + (row.Total ?? getRowTotal(row)),
                0
              )}
            </td>
            {levels.map((lvl) => (
                          <td key={lvl} className={(getLevelTotal(lvl) > 0 ? getHeaderClass(lvl): "" ) + " fw-bold"}>
                            {getLevelTotal(lvl)}
                          </td>
                        ))}
{/*}
            {levels.map((lvl) => {
              // Ortalama hesapla (sadece 0 olmayanlar)
              const nonZeroValues = data
                .map((row) => row[lvl])
                .filter((v) => v > 0 && v !== undefined);
              const avg = nonZeroValues.length
                ? (nonZeroValues.reduce((acc, val) => acc + val, 0) / nonZeroValues.length).toFixed(1)
                : '0.0';
              return (
                <td key={lvl} className={(avg > 0 ? getHeaderClass(lvl): "") + " fw-bold" }>
                  {avg}
                </td>
              );
            })}
            */}
          </tr>
        </tbody>
      </table>

      {!isStudent && (
        <div className="text-end">
          <button className="btn btn-primary" onClick={handleUpdate}>
            Update
          </button>
        </div>
      )}
    </div>
  );
}
